import * as React from 'react';
import { Space, Text, Table, RadioGroup, RadioButton } from 'components';
import styled from 'styled-components';
import type { JsonObject } from '@/app-package';
import { ListingDoc } from '@bb/domain/dist/schemas';

type RoomDetailsProps = {
  rooms: JsonObject<ListingDoc>['rooms'];
  roomUnit: 'm' | 'ft';
  country?: string;
};

const RoomDetails: React.FC<RoomDetailsProps> = ({
  rooms,
  roomUnit,
  country,
}) => {
  // if us org always ft by default
  const [lengthUnit, setLengthUnit] = React.useState(
    country === 'USA' || roomUnit === 'ft' ? 3.28 : 1,
  );

  const columns = [
    { title: '', dataIndex: 'id', key: 'id' },
    { title: 'Level', dataIndex: 'level', key: 'level' },
    { title: 'Room', dataIndex: 'room', key: 'room' },
    { title: 'Length', dataIndex: 'length', key: 'length' },
    { title: 'Width', dataIndex: 'width', key: 'width' },
    {
      title: 'Description 1',
      dataIndex: 'description_1',
      key: 'description_1',
    },
    {
      title: 'Description 2',
      dataIndex: 'description_2',
      key: 'description_2',
    },
    {
      title: 'Description 3',
      dataIndex: 'description_3',
      key: 'description_3',
    },
  ];
  const data = rooms.map(room => ({
    ...room,
    key: room.id,
    length: room.length && (+room.length * lengthUnit).toFixed(2),
    width: room.width && (+room.width * lengthUnit).toFixed(2),
  }));

  return (
    <>
      <StyledSpace>
        <Text strong>Rooms</Text>
        <small> w/ Dimensions in - </small>
        <RadioGroup
          value={lengthUnit}
          size="small"
          buttonStyle="solid"
          onChange={({ target: { value } }) => setLengthUnit(value)}
        >
          <RadioButton value={1}>Meters</RadioButton>
          <RadioButton value={3.28}>Feet</RadioButton>
        </RadioGroup>
      </StyledSpace>

      <Table columns={columns} dataSource={data} pagination={false} />
    </>
  );
};

export default RoomDetails;

const StyledSpace = styled(Space)`
  display: flex;
  align-items: center;
`;
